import { render, staticRenderFns } from "./BackToTenderBtn.vue?vue&type=template&id=08dea4b5"
import script from "./BackToTenderBtn.vue?vue&type=script&lang=js"
export * from "./BackToTenderBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports